import { render, staticRenderFns } from "./GinIndexcon.vue?vue&type=template&id=70e5c84d&scoped=true"
import script from "./GinIndexcon.vue?vue&type=script&lang=js"
export * from "./GinIndexcon.vue?vue&type=script&lang=js"
import style0 from "./GinIndexcon.vue?vue&type=style&index=0&id=70e5c84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5c84d",
  null
  
)

export default component.exports